import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as LuIcons from 'react-icons/lu';
const { LuMenu, LuX } = LuIcons;
import SafeIcon from '../common/SafeIcon';
import Logo from '../common/Logo';

export default function Header({ onLogoClick, isDashboard }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Features', href: '#features' },
    { name: 'How it Works', href: '#how-it-works' },
    { name: 'Pricing', href: '#pricing' },
    { name: 'FAQ', href: '#faq' },
  ];

  return (
    <header className="fixed top-0 w-full z-50 bg-[#ffffff] border-b border-[#E5E7EB] shadow-[0_2px_15px_rgba(0,0,0,0.02)] transition-all duration-300">
      <div className="container mx-auto px-4 md:px-8 h-[90px] md:h-[100px] flex items-center justify-between">
        
        {/* Logo Section */}
        <div 
          className="w-[70%] md:w-[35%] flex items-center justify-start cursor-pointer transition-transform duration-200 hover:opacity-90" 
          onClick={onLogoClick}
        >
          <Logo className="h-[55px] md:h-[80px] w-auto" />
        </div>

        {/* Navigation Section - Centered */}
        {!isDashboard && (
          <nav className="hidden md:flex flex-1 items-center justify-center gap-8 lg:gap-12">
            {navLinks.map((link) => (
              <a 
                key={link.name} 
                href={link.href} 
                className="text-[16px] whitespace-nowrap font-[500] tracking-[0.015em] text-gray-700 hover:text-[#2563EB] transition-colors"
                style={{ fontSize: '16px', whiteSpace: 'nowrap' }}
              >
                {link.name}
              </a>
            ))}
          </nav>
        )}

        {/* CTA Section */}
        <div className="hidden md:flex w-[35%] items-center justify-end gap-6">
          {!isDashboard ? (
            <>
              <button className="text-[16px] whitespace-nowrap font-[500] text-gray-600 hover:text-[#111827] transition-colors">
                Login
              </button>
              <button className="bg-gradient-to-r from-[#2563EB] to-[#3B82F6] hover:from-[#1D4ED8] hover:to-[#2563EB] text-white font-[600] text-[16px] py-[12px] px-[28px] rounded-full shadow-lg shadow-blue-500/20 hover:shadow-xl hover:shadow-blue-500/30 transition-all duration-300 transform hover:-translate-y-0.5 whitespace-nowrap">
                Get Started
              </button>
            </>
          ) : (
            <button 
              className="bg-white border border-gray-200 hover:bg-gray-50 text-gray-800 font-[600] text-[16px] py-[10px] px-[24px] rounded-full shadow-sm transition-all duration-200 whitespace-nowrap"
              onClick={onLogoClick}
            >
              New Search
            </button>
          )}
        </div>

        {/* Mobile Menu Toggle */}
        <button 
          className="md:hidden p-2 text-gray-600 hover:text-gray-900 transition-colors" 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <SafeIcon icon={mobileMenuOpen ? LuX : LuMenu} className="text-3xl" />
        </button>
      </div>

      {/* Mobile Nav Dropdown */}
      <AnimatePresence>
        {mobileMenuOpen && !isDashboard && (
          <motion.div 
            initial={{ opacity: 0, height: 0 }} 
            animate={{ opacity: 1, height: 'auto' }} 
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-white border-b border-gray-100 overflow-hidden shadow-xl"
          >
            <div className="flex flex-col px-6 py-8 gap-6">
              {navLinks.map((link) => (
                <a 
                  key={link.name} 
                  href={link.href} 
                  className="text-[18px] font-[600] text-gray-800" 
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.name}
                </a>
              ))}
              <hr className="border-gray-100 my-2" />
              <button className="text-[18px] font-[600] text-gray-800 text-left">Login</button>
              <button className="bg-gradient-to-r from-[#2563EB] to-[#3B82F6] text-white py-4 rounded-xl font-[600] text-[18px] mt-2 shadow-lg shadow-blue-500/20">
                Get Started
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}